// extracted by mini-css-extract-plugin
export var button = "T+lcqBaR";
export var buttonColorLime = "r87gWx0N";
export var buttonColorCactus = "FAu6fISm";
export var buttonColorRed = "_011OsAIP";
export var buttonColorYellow = "Y71GgPhW";
export var buttonColorDisabled = "JDV3ScYg";
export var buttonColorWhite = "-Sk94Iuo";
export var buttonColorGray = "BSBBqqOH";
export var buttonColorDarkviolet = "brY0VK9n";
export var buttonColorCharcoal = "_8Cvts-5v";
export var buttonTypeSolid = "ScDfV6KF";
export var buttonTypeOutline = "gx9ZM+oN";
export var buttonTypeGhost = "J3KDZ4i9";
export var icon = "bIvNWKVc";
export var iconLeft = "C8n6tZd2";
export var iconRight = "B0yEPVjR";